import React, { PureComponent } from 'react';
import { object, func } from 'prop-types';
import Card from '../Card/Card';
import OfferCardInfo from './OfferCardInfo';
import OfferCardControls from './OfferCardControls';
import OfferCardItem from './OfferCardItem';

class OfferCard extends PureComponent {
  static propTypes = {
    offer: object.isRequired,
    onRequestOfferAccess: func.isRequired,
    onRefuseOfferAccess: func.isRequired,
    onFlowCreate: func.isRequired,
  };

  render() {
    const { offer, onRequestOfferAccess, onRefuseOfferAccess, offerSettings, onFlowCreate } =
      this.props;

    return (
      <Card.Body className="no-padding">
        <div className="offer-card">
          <OfferCardInfo
            title={offer.title}
            id={offer.id}
            url={offer.url}
            modifies={offer.modifies}
            pic={`${offerSettings['images_path']}${offer.images ? offer.images[100] : ''}`}
            admit={offer.admit}
            categories={offer.categories}
          >
            <OfferCardControls
              offerId={offer.id}
              isMy={offer.modifies.is_my}
              hasAccess={offer.admit.has_access}
              hasPromo={offer.hasPromo}
              onRequestOfferAccess={onRequestOfferAccess}
              onRefuseOfferAccess={onRefuseOfferAccess}
              onFlowCreate={onFlowCreate}
            />
          </OfferCardInfo>

          {offer.full_description && (
            <OfferCardItem
              id="offer.description"
              defaultMessage="Description"
              className="offer-description"
              html={offer.full_description}
            />
          )}

          {offer.rules && (
            <OfferCardItem
              id="offer.rules"
              className="offer-rules"
              defaultMessage="Offer's Rules"
              html={offer.rules}
            />
          )}
        </div>
      </Card.Body>
    );
  }
}

export default OfferCard;
